import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Quotes = () => {
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="text-center shadow-sm p-3 mb-5 bg-white rounded">
            <Card.Body>
              <blockquote className="blockquote mb-0">
                <p>
                  "Perfection is achieved not when there is nothing more to add, but rather when there is nothing more to take away."
                </p>
                <footer className="blockquote-footer mt-2">
                  Antoine de Saint-Exupéry
                </footer>
              </blockquote>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Quotes;